export default __webpack_public_path__ + "static/media/logo.a04f4511.svg";